import React from "react"
import { HeaderPropTypes } from "./propTypes"
import HeaderDesktop from "./HeaderDesktop"
import HeaderMobile from "./HeaderMobile"
import useScreenSize from "../../../hooks/useScreenSize"

const Header = props => {
    const screenSize = useScreenSize()
    return screenSize?.isMobileOrTablet ? <HeaderMobile {...props} /> : <HeaderDesktop {...props} />
}

Header.propTypes = HeaderPropTypes

export default Header
